export default {
  company: "Công ty",
  share_holder: "Tổng quản trị",
  super_senior: "Quản trị",
  senior: "Cổ đông",
  master: "Tổng đại lý",
  agent: "Đại lý",
  member: "Hội viên",

  account_id: "Tên tài khoản",
  action: "Hoạt động",
  available_credit: "Tín dụng có sẵn",
  active: "Hoạt Động",
  account_balance: "Số dư tài khoản",
  agent_credit: "Đại lý tín dụng",
  authority: "Quyền",
  account_information: "Thông tin tài khoản",
  account_list: "Danh sách tài khoản",
  audit_by: "kiểm toán Bằng",
  add_account: "Thêm tài khoản",
  add_sub_account: "Thêm một tài khoản phụ",
  authority_option: "Ủy quyền Lựa chọn",
  account: "Tài khoản",
  access_log: "Nhật ký truy cập",
  account_log: "Nhật ký tài khoản",
  account_details: "Chi tiết tài khoản",
  action_by: "Hành động bởi",
  away_team_name: "Tên đội khách",
  amount: "Số tiền",
  account_before_balance: "Tài khoản trước số dư",
  account_after_balance: "Tài khoản sau khi số dư",
  active_bet_list: "Danh sách cá cược tích cực",
  agent_win_all: "Đặc vụ chiến thắng tất cả",
  agent_win_half: "Đặc vụ thắng một nửa",
  agent_lose_all: "Đặc vụ mất tất cả",
  agent_lose_half: "Đặc vụ mất một nửa",
  accumulate_win: "Tích lũy Win",
  add_sub: "Thêm một tài khoản phụ",
  account_type: "Kiểu tài khoản",
  account_pt: "Tài khoản PT",
  account_min: "Tài khoản tối thiểu",
  away_score: "Tỷ số đội khách",
  add_secondary_full: "Thêm một tài khoản phụ",
  accumulate_balance: "Số dư lũy kế",
  away: "Khách",
  aa: "Hiệp 1: Khách | Cả trận: Khách",
  ad: "Hiệp 1: Khách | Cả trận: Hoà",
  ah: "Hiệp 1: Khách | Cả trận: Chủ nhà",
  anb: "Khách không bàn thắng",
  all: "Tất cả",
  account_existed: "Tài khoản tồn tại.",
  account_not_existed: "Tài khoản không tồn tại.",
  account_status: "Tình trạng tài khoản",
  account_block: "Khối tài khoản",
  account_unblock: "Bỏ chặn tài khoản",
  add_secondary: "Thêm tài khoản thứ 2",
  agent_bulk: "Đại lý lớn",
  abandoned: "Bị bỏ rơi",
  account_list_alert: "Cảnh báo người chơi",
  adjustment: "Điều chỉnh",

  balance: "Thăng bằng",
  bet: "Cá cược",
  block: "Bị chặn",
  blocked: "Bị chặn",
  back: "Back",
  bet_limit: "Giới hạn đặt cược",
  basketball: "Bóng rổ",
  baseball: "Bóng chày",
  bet_limit_log: "Lịch sử giới hạn cược",
  browser_agent: "Trình duyệt của đại lý",
  bet_limit_packages: "Gói giới hạn cược",
  ball: "Trái bóng",
  bet_count: "Số cược",
  bet_type: "Loại cược",
  bl: "Giới hạn đặt cược",
  basketball_min_bet: "@:ui.basketball @:ui.min_bet",
  basketball_max_bet: "@:ui.basketball @:ui.max_bet",
  basketball_max_per_match: "@:ui.basketball @:ui.max_per_match",
  baseball_min_bet: "@:ui.baseball @:ui.min_bet",
  baseball_max_bet: "@:ui.baseball @:ui.max_bet",
  baseball_max_per_match: "@:ui.baseball @:ui.max_per_match",
  bet_list: "Danh sách đặt cược",
  bet_list_4d: "Danh sách đặt cược 4D",
  bet_list_esports2: "Danh sách đặt cược THỂ THAO ĐIỆN TỬ Hai",
  bs: "Tỉ số hòa",

  credit: "tín dụng",
  cm: "Ủy ban",
  close: "Đã đóng",
  cancel: "Hủy bỏ",
  continue: "Tiếp tục",
  created_on: "Đã được tạo ra",
  copy_and_create: "Sao chép và tạo",
  copy: "Sao chép",
  confirm_password: "Xác nhận mật khẩu",
  confirm_security_code: "Confirm security code",
  contact_phone: "Điện thoại",
  contact_email: "Email",
  cash_balance: "Số dư tiền mặt",
  currency: "Tiền tệ",
  credit_limit: "Giới hạn tín dụng",
  credit_balance: "Tín dụng / Số dư",
  commission: "Uỷ ban",
  correct_score: "Tỷ số chính xác",
  correct_score_bl: "Tỷ số chính xác (@:ui.soccer)",
  commission_log: "Lịch sử hoa hồng",
  current_balance: "Số dư hiện tại",
  cancelled_bet_list: "Danh sách đặt cược bị hủy",
  category: "thể loại",
  copy_to_bottom: "Sao chép xuống dưới",
  comm_sportsbook_hdp_a: "Kèo A",
  comm_sportsbook_hdp_b: "Kèo B",
  comm_sportsbook_hdp_c: "Kèo C",
  comm_sportsbook_hdp_d: "Kèo D",
  comm_sportsbook_hdp_e: "Kèo E",
  comm_sportsbook_hdp_f: "Kèo F",
  comm_sportsbook_hdp_g: "Kèo G",
  comm_sportsbook_hdp_h: "Kèo H",
  comm_sportsbook_hdp_i: "Kèo I",
  comm_sportsbook_hdp_j: "Kèo J",
  comm_sportsbook_1x2: "1X2",
  comm_sportsbook_others: "Khác",
  comm_sportsbook_hdp_packages: "Gói kèo",
  comm_slots: "Xèng",
  comm_casino: "Sòng bạc trực tuyến",
  comm_lotto: "Xổ số",
  comm_keno: "Trò chơi số keno",
  comm_cockfight: "THỂ THAO ĐIỆN TỬ Hai",
  comm_lottery_1d: "Xổ số 1D",
  comm_lottery_2d: "Xổ số 2D",
  comm_lottery_3d: "Xổ số 3D",
  comm_lottery_4d: "Xổ số 4D",
  comm_tournament: "Tournament",
  completed: "xổ số",
  clean_sheet: "Sạch lưới",
  cockfight: "THỂ THAO ĐIỆN TỬ Hai",
  esports2: "THỂ THAO ĐIỆN TỬ Hai",
  cockfight_bet_limit_packages: "Giới hạn Gói cược THỂ THAO ĐIỆN TỬ Hai",
  combination: "Combination",
  cs_min_bet: "@:ui.correct_score @:ui.min_bet",
  cs_max_bet: "@:ui.correct_score @:ui.max_bet",
  cs_max_per_match: "@:ui.correct_score @:ui.max_per_match",

  combine: {
    bet_limit_A: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_B: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_C: "Limit C (@:ui.min = 20 @:ui.max = 1000)",
    bet_limit_D: "Limit D (@:ui.min = 200 @:ui.max = 5000)",
    bet_limit_E: "Limit E (@:ui.min = 500 @:ui.max = 10000)",
    bet_limit_F: "Limit F (@:ui.min = 500 @:ui.max = 20000)",
    bet_limit_G: "Limit G (@:ui.min = 500 @:ui.max = 30000)",

    // bet_limit_AUDA: "Limit A (@:ui.min = 1 @:ui.max = 100)",
    // bet_limit_AUDB: "Limit B (@:ui.min = 1 @:ui.max = 125)",
    // bet_limit_AUDC: "Limit C (@:ui.min = 1 @:ui.max = 400)",
    // bet_limit_AUDD: "Limit D (@:ui.min = 5 @:ui.max = 1,500)",
    // bet_limit_AUDE: "Limit E (@:ui.min = 5 @:ui.max = 2,500)",
    // bet_limit_AUDF: "Limit F (@:ui.min = 5 @:ui.max = 5,000)",
    // bet_limit_AUDG: "Limit G (@:ui.min = 5 @:ui.max = 10,000)",

    bet_limit_KRWA: "Limit A (@:ui.min = 1,500 @:ui.max = 200,000)",
    bet_limit_KRWB: "Limit B (@:ui.min = 2,000 @:ui.max = 200,000)",
    bet_limit_KRWC: "Limit C (@:ui.min = 2,000 @:ui.max = 400,000)",
    bet_limit_KRWD: "Limit D (@:ui.min = 4,000 @:ui.max = 800,000)",
    bet_limit_KRWE: "Limit E (@:ui.min = 4,000 @:ui.max = 2,000,000)",
    bet_limit_KRWF: "Limit F (@:ui.min = 4,000 @:ui.max = 4,000,000)",
    bet_limit_KRWG: "Limit G (@:ui.min = 4,000 @:ui.max = 6,000,000)",

    bet_limit_CNYA: "Limit A (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_CNYB: "Limit B (@:ui.min = 10 @:ui.max = 1000)",
    bet_limit_CNYC: "Limit C (@:ui.min = 10 @:ui.max = 2000)",
    bet_limit_CNYD: "Limit D (@:ui.min = 20 @:ui.max = 5000)",
    bet_limit_CNYE: "Limit E (@:ui.min = 20 @:ui.max = 10000)",
    bet_limit_CNYF: "Limit F (@:ui.min = 400 @:ui.max = 20000)",
    bet_limit_CNYG: "Limit G (@:ui.min = 20 @:ui.max = 50000)",

    bet_limit_HKDA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_HKDB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_HKDC: "Limit C (@:ui.min = 20 @:ui.max = 1000)",
    bet_limit_HKDD: "Limit D (@:ui.min = 200 @:ui.max = 5000)",
    bet_limit_HKDE: "Limit E (@:ui.min = 500 @:ui.max = 10000)",
    bet_limit_HKDF: "Limit F (@:ui.min = 500 @:ui.max = 20000)",
    bet_limit_HKDG: "Limit G (@:ui.min = 500 @:ui.max = 30000)",

    bet_limit_SGDA: "Limit A (@:ui.min = 1 @:ui.max = 100)",
    bet_limit_SGDB: "Limit B (@:ui.min = 1 @:ui.max = 200)",
    bet_limit_SGDC: "Limit C (@:ui.min = 5 @:ui.max = 500)",
    bet_limit_SGDD: "Limit D (@:ui.min = 5 @:ui.max = 1,000)",
    bet_limit_SGDE: "Limit E (@:ui.min = 10 @:ui.max = 2,000)",
    bet_limit_SGDF: "Limit F (@:ui.min = 5 @:ui.max = 5,000)",
    bet_limit_SGDG: "Limit G (@:ui.min = 5 @:ui.max = 10,000)",
    
    bet_limit_VNDA: "Limit A (@:ui.min = 10 @:ui.max = 2,000)",
    bet_limit_VNDB: "Limit B (@:ui.min = 10 @:ui.max = 3,000)",
    bet_limit_VNDC: "Limit C (@:ui.min = 40 @:ui.max = 5,000)",
    bet_limit_VNDD: "Limit D (@:ui.min = 80 @:ui.max = 25,000)",
    bet_limit_VNDE: "Limit E (@:ui.min = 80 @:ui.max = 50,000)",
    bet_limit_VNDF: "Limit F (@:ui.min = 80 @:ui.max = 100,000)",
    bet_limit_VNDG: "Limit G (@:ui.min = 80 @:ui.max = 150,000)",
	
	  bet_limit_MYRA: "Limit A (@:ui.min = 1 @:ui.max = 500)",
    bet_limit_MYRB: "Limit B (@:ui.min = 5 @:ui.max = 500)",
    bet_limit_MYRC: "Limit C (@:ui.min = 10 @:ui.max = 1,000)",
    bet_limit_MYRD: "Limit D (@:ui.min = 10 @:ui.max = 2,500)",
    bet_limit_MYRE: "Limit E (@:ui.min = 100 @:ui.max = 5,000)",
    bet_limit_MYRF: "Limit F (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_MYRG: "Limit G (@:ui.min = 500 @:ui.max = 20,000)",
	
	  bet_limit_USDA: "Limit A (@:ui.min = 1 @:ui.max = 100)",
    bet_limit_USDB: "Limit B (@:ui.min = 1 @:ui.max = 125)",
    bet_limit_USDC: "Limit C (@:ui.min = 1 @:ui.max = 400)",
    bet_limit_USDD: "Limit D (@:ui.min = 5 @:ui.max = 1,500)",
    bet_limit_USDE: "Limit E (@:ui.min = 5 @:ui.max = 2,500)",
    bet_limit_USDF: "Limit F (@:ui.min = 5 @:ui.max = 5,000)",
    bet_limit_USDG: "Limit G (@:ui.min = 5 @:ui.max = 10,000)",
	
	  bet_limit_THBA: "Limit A (@:ui.min = 10 @:ui.max = 2,500)",
    bet_limit_THBB: "Limit B (@:ui.min = 50 @:ui.max = 5,000)",
    bet_limit_THBC: "Limit C (@:ui.min = 100 @:ui.max = 10,000)",
    bet_limit_THBD: "Limit D (@:ui.min = 100 @:ui.max = 50,000)",
    bet_limit_THBE: "Limit E (@:ui.min = 100 @:ui.max = 100,000)",
    bet_limit_THBF: "Limit F (@:ui.min = 100 @:ui.max = 200,000)",
    bet_limit_THBG: "Limit G (@:ui.min = 100 @:ui.max = 300,000)",
	
	  bet_limit_IDRA: "Limit A (@:ui.min = 5 @:ui.max = 1,000)",
    bet_limit_IDRB: "Limit B (@:ui.min = 20 @:ui.max = 1,500)",
    bet_limit_IDRC: "Limit C (@:ui.min = 20 @:ui.max = 3,000)",
    bet_limit_IDRD: "Limit D (@:ui.min = 25 @:ui.max = 15,000)",
    bet_limit_IDRE: "Limit E (@:ui.min = 25 @:ui.max = 30,000)",
    bet_limit_IDRF: "Limit F (@:ui.min = 25 @:ui.max = 60,000)",
    bet_limit_IDRG: "Limit G (@:ui.min = 25 @:ui.max = 100,000)",

    bet_limit_MMKA: "Limit A (@:ui.min = 1 @:ui.max = 200)",
    bet_limit_MMKB: "Limit B (@:ui.min = 2 @:ui.max = 200)",
    bet_limit_MMKC: "Limit C (@:ui.min = 2 @:ui.max = 500)",
    bet_limit_MMKD: "Limit D (@:ui.min = 2 @:ui.max = 1,000)",
    bet_limit_MMKE: "Limit E (@:ui.min = 4 @:ui.max = 2,000)",
    bet_limit_MMKF: "Limit F (@:ui.min = 4 @:ui.max = 5,000)",
    bet_limit_MMKG: "Limit G (@:ui.min = 4 @:ui.max = 10,000)",

    bet_limit_MMOA: "Limit A (@:ui.min = 1 @:ui.max = 200)",
    bet_limit_MMOB: "Limit B (@:ui.min = 2 @:ui.max = 200)",
    bet_limit_MMOC: "Limit C (@:ui.min = 2 @:ui.max = 500)",
    bet_limit_MMOD: "Limit D (@:ui.min = 2 @:ui.max = 1,000)",
    bet_limit_MMOE: "Limit E (@:ui.min = 4 @:ui.max = 2,000)",
    bet_limit_MMOF: "Limit F (@:ui.min = 4 @:ui.max = 5,000)",
    bet_limit_MMOG: "Limit G (@:ui.min = 4 @:ui.max = 10,000)",

    bet_limit_ARSA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_ARSB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_ARSC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_ARSD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_ARSE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_ARSF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_ARSG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_AUDA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_AUDB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_AUDC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_AUDD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_AUDE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_AUDF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_AUDG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_BDTA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_BDTB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_BDTC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_BDTD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_BDTE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_BDTF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_BDTG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_BNDA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_BNDB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_BNDC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_BNDD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_BNDE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_BNDF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_BNDG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_BRLA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_BRLB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_BRLC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_BRLD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_BRLE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_BRLF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_BRLG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_EURA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_EURB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_EURC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_EURD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_EURE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_EURF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_EURG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_GOOA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_GOOB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_GOOC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_GOOD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_GOOE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_GOOF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_GOOG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_INRA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_INRB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_INRC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_INRD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_INRE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_INRF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_INRG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_JPYA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_JPYB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_JPYC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_JPYD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_JPYE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_JPYF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_JPYG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_NPRA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_NPRB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_NPRC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_NPRD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_NPRE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_NPRF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_NPRG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_PKRA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_PKRB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_PKRC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_PKRD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_PKRE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_PKRF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_PKRG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_TNDA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_TNDB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_TNDC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_TNDD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_TNDE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_TNDF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_TNDG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_USTA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_USTB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_USTC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_USTD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_USTE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_USTF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_USTG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_PHPA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_PHPB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_PHPC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_PHPD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_PHPE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_PHPF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_PHPG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_LAKA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_LAKB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_LAKC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_LAKD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_LAKE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_LAKF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_LAKG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_LKRA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_LKRB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_LKRC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_LKRD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_LKRE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_LKRF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_LKRG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_KHRA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_KHRB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_KHRC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_KHRD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_KHRE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_KHRF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_KHRG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_AEDA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_AEDB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_AEDC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_AEDD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_AEDE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_AEDF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_AEDG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_CADA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_CADB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_CADC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_CADD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_CADE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_CADF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_CADG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_CHFA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_CHFB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_CHFC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_CHFD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_CHFE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_CHFF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_CHFG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_DKKA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_DKKB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_DKKC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_DKKD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_DKKE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_DKKF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_DKKG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_GBPA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_GBPB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_GBPC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_GBPD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_GBPE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_GBPF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_GBPG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_MXNA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_MXNB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_MXNC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_MXND: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_MXNE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_MXNF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_MXNG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_NGNA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_NGNB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_NGNC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_NGND: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_NGNE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_NGNF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_NGNG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_NOKA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_NOKB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_NOKC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_NOKD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_NOKE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_NOKF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_NOKG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_NZDA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_NZDB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_NZDC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_NZDD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_NZDE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_NZDF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_NZDG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_RUBA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_RUBB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_RUBC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_RUBD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_RUBE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_RUBF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_RUBG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_SEKA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_SEKB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_SEKC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_SEKD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_SEKE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_SEKF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_SEKG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_TRYA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_TRYB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_TRYC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_TRYD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_TRYE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_TRYF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_TRYG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_ZARA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_ZARB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_ZARC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_ZARD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_ZARE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_ZARF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_ZARG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_COPA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_COPB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_COPC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_COPD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_COPE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_COPF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_COPG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",
    bet_limit_PENA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_PENB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_PENC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_PEND: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_PENE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_PENF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_PENG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",

    bet_limit_MNTA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_MNTB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_MNTC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_MNTD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_MNTE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_MNTF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_MNTG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",

    bet_limit_KESA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_KESB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_KESC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_KESD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_KESE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_KESF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_KESG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",

    bet_limit_PGKA: "Limit A (@:ui.min = 5 @:ui.max = 250)",
    bet_limit_PGKB: "Limit B (@:ui.min = 10 @:ui.max = 500)",
    bet_limit_PGKC: "Limit C (@:ui.min = 20 @:ui.max = 1,000)",
    bet_limit_PGKD: "Limit D (@:ui.min = 200 @:ui.max = 5,000)",
    bet_limit_PGKE: "Limit E (@:ui.min = 500 @:ui.max = 10,000)",
    bet_limit_PGKF: "Limit F (@:ui.min = 500 @:ui.max = 20,000)",
    bet_limit_PGKG: "Limit G (@:ui.min = 500 @:ui.max = 30,000)",

    bet_limit_lottery_MYRA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_AUDA: "Package A (@:m.D_BIG:15 @:m.D_SMALL:15 SA:6 @:ui.min:1)",
    bet_limit_lottery_CNYA: "Package A (@:m.D_BIG:100 @:m.D_SMALL:100 SA:40 @:ui.min:2)",
    bet_limit_lottery_HKDA: "Package A (@:m.D_BIG:100 @:m.D_SMALL:100 SA:40 @:ui.min:2)",
    bet_limit_lottery_IDRA: "Package A (@:m.D_BIG:150 @:m.D_SMALL:150 SA:60 @:ui.min:3)",
    bet_limit_lottery_KRWA: "Package A (@:m.D_BIG:13000 @:m.D_SMALL:13000 SA:5000 @:ui.min:300)",
    bet_limit_lottery_SGDA: "Package A (@:m.D_BIG:15 @:m.D_SMALL:15 SA:6 @:ui.min:1)",
    bet_limit_lottery_THBA: "Package A (@:m.D_BIG:500 @:m.D_SMALL:500 SA:200 @:ui.min:10)",
    bet_limit_lottery_USDA: "Package A (@:m.D_BIG:10 @:m.D_SMALL:10 SA:5 @:ui.min:1)",
    bet_limit_lottery_VNDA: "Package A (@:m.D_BIG:250 @:m.D_SMALL:250 SA:100 @:ui.min:5)",
    bet_limit_lottery_MMKA: "Package A (@:m.D_BIG:15 @:m.D_SMALL:15 SA:6 @:ui.min:1)",
    bet_limit_lottery_MMOA: "Package A (@:m.D_BIG:15 @:m.D_SMALL:15 SA:6 @:ui.min:1)",

    bet_limit_lottery_ARSA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_BDTA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_BNDA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_BRLA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_EURA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_GOOA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_INRA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_JPYA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_NPRA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_PKRA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_TNDA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_USTA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_PHPA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_LAKA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_LKRA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_KHRA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_AEDA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_CADA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_CHFA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_DKKA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_GBPA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_MXNA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_NGNA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_NOKA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_NZDA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_RUBA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_SEKA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_TRYA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_ZARA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_COPA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_PENA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_MNTA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_KESA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    bet_limit_lottery_PGKA: "Package A (@:m.D_BIG:50 @:m.D_SMALL:50 SA:20 @:ui.min:1)",
    
    comm_limit_A: "Nhóm A",
    comm_limit_B: "Nhóm B",
    comm_limit_C: "Nhóm C",
    comm_limit_D: "Nhóm D",
    comm_limit_E: "Nhóm E",
    comm_limit_F: "Nhóm F",
    comm_limit_G: "Nhóm G",
    comm_limit_H: "Nhóm H",
    comm_limit_I: "Nhóm I",
    comm_limit_J: "Nhóm J",

    comm_parlay_mmo_a: "Parlay MMO (2-3)",
    comm_parlay_mmo_b: "Parlay MMO (4-12)",

    reset_password: "@:ui.reset @:ui.password",
    edit_password: "@:ui.edit @:ui.password",
    edit_settings: "@:ui.edit @:ui.settings",
    edit_profile: "@:ui.edit @:ui.profile",
    edit_authority: "@:ui.edit @:ui.authority",
    update_commission: "@:ui.update @:ui.commission",
    update_bet_limit: "@:ui.update @:ui.bet_limit",
    update_position_taking: "@:ui.update @:ui.position_taking",
    update_profile: "@:ui.update @:ui.profile"
  },

  downline_id: "Tên cấp dưới",
  disabled: "tên cấp dưới",
  downline: "Tuyến dưới",
  dashboard: "bảng điều khiển",
  downline_list: "Liệt kê tuyến dưới",
  double_chance: "Nhân đôi cơ hội",
  downline_credit: "Tín dụng cấp dưới",
  date: "ngày",
  data: "Dữ liệu",
  date_time: "Ngày và giờ",
  date_range: "Phạm vi ngày",
  details: "Chi tiết",
  draw: "Hoà",
  daily_statement: "Hoà",
  daily_statement_member: "Sao kê hội viên",
  daily_winlose: "Thắng thua ngày",
  daily_winlose_simple: "Thắng thua ngày đơn giản",
  daily_winlose_details: "Thắng thua ngày chi tiết",
  daily_reset: "Thiết lập lại hàng ngày",
  daily_winlose_platform: "Thắng thua theo dạng thể loại",
  daily_winlose_match: "Thắng thua theo trận",
  detail: "Thắng thua theo trận",
  downline_outstanding: "Mã đang chạy của cấp dưới",
  dd: "Hiệp 1: Hoà | Cả trận: Hoà",
  dh: "Hiệp 1: Hoà | Cả trận: Chủ nhà",
  da: "Hiệp 1: Hoà | Cả trận: Khách",
  dnb: "Hoà không bàn thắng",
  draw_cancel: "Hoà",
  default: "Hoà / Huỷ",
  deposit: "Tiền gửi",

  edit: "Chỉnh sửa",
  enter_information: "Nhập thông tin",
  enable: "Cho phép",
  esports: "Thể thao điện tử",
  edit_account: "Chỉnh sửa tài khoản",
  edit_limit: "Chỉnh sửa giới hạn",
  early: "Sớm",
  event: "Chương trình",
  enabled: "Bật",
  esports_min_bet: "@:ui.esports @:ui.min_bet",
  esports_max_bet: "@:ui.esports @:ui.max_bet",
  esports_max_per_match: "@:ui.esports @:ui.max_per_match",
  even: "Lẻ",
  edited: "Được chỉnh sửa",
  export_excel: "Xuất Excel",

  from: "Từ",
  full: "Đầy",

  forecast: "Dự báo",
  forecast_soccer: "Dự báo (bóng đá)",
  freeze: "Đóng băng",
  full_name: "Họ và tên",
  full_mode: "Dạng tổng",
  first_hdp: "Kèo hiệp 1",
  first_ou: "Tài xỉu hiêpj 1",
  fh: "FH",
  forecast_details: "Chi tiết dự báo",
  full_time: "Cả trận",
  fglg: "@:m.BT_FG/@:m.BT_LG",
  first_goal: "Bàn thắng đầu",
  first_half: "Nửa hiệp 1",
  fold: "Kết hợp",

  grand_total: "Tổng cộng",
  gross_commission: "Tổng hoa hồng",
  game_name: "Tên của trò chơi",
  game_provider: "Nhà cung cấp trò chơi",
  game_result: "Kết quả trò chơi",
  game_result_details: "Chi tiết kết quả trò chơi",
  gross_winlose: "Tổng thắng thua",
  game_type: "Dạng trò chơi",
  game_rules: "Quy tắc trò chơi xèng",

  ht: "HT",
  half: "Một nửa",
  half_time: "Nửa thời gian",
  home: "Trang Chủ",
  hdp: "Trang Chủ",
  hdp_packages: "Gói kèo",
  home_team_name: "Đội Tên",
  home_score: "Điểm về đích",
  hh: "Chủ nhà | FT: Chủ nhà",
  hd: "Chủ nhà | FT: Hoà",
  ha: "Chủ nhà | FT: Khách",
  hdpou: "@:ui.hdp/@:ui.ou",
  htft: "@:ui.half_time/@:ui.full_time",
  hnb: "Chủ nhà không bàn thắng",

  ip_address: "Địa chỉ IP",
  id: "ID",

  jackpot: "Giải độc đắc",

  key: "Chìa khóa",
  keno: "Keno",
  keno_bet_limit_packages: "Gói giới hạn cược Keno",

  log_id: "Đăng nhập ID",
  lottery: "Xổ số",
  lottery_1d: "Xổ số 1D",
  lottery_2d: "Xổ số 2D",
  lottery_3d: "Xổ số 3D",
  lottery_4d: "Xổ số 4D",
  lotto: "Xổ số",
  log: "Lịch sử",
  list: "Danh sách",
  logs: "Lịch sử",
  login: "Đăng nhập",
  logout: "Đăng xuất",
  login_ip: "Đăng nhập IP",
  login_id: "Đăng nhập ID",
  last_name: "Tên họ",
  live_casino: "Sóng bạc trực tuyến",
  livecasino: "Sóng bạc trực tuyến",
  lastweek: "Tuần trước",
  lastmonth: "Tháng trước",
  last3month: "3 tháng trước",
  league_id: "Tên giải đấu",
  league_name: "Tên giải đấu",
  league: "Giải đấu",
  livecasino_platform: "Nền tảng sóng bài trực tuyến",
  livecasino_upline_pt : "@:ui.live_casino @:ui.upline_pt",
  livecasino_account_pt : "@:ui.live_casino @:ui.account_pt",
  livecasino_upline_remaining : "@:ui.live_casino @:ui.upline_remaining",
  livecasino_account_min : "@:ui.live_casino @:ui.account_min",
  livecasino_bet_limit_packages: "Gói giới hạn cược sòng bài trực tuyến",
  last_goal: "Bàn thắng cuối",
  live: "Trực tiếp",
  lose: "Thua",
  lose_half: "Thua nữa",
  last_week: "Tuần trước",
  last_month: "Tháng trước",
  lotto_bet_limit_packages: "Gói giới hạn cược xổ số",
  lottery_bet_limit_packages: "Gói giới hạn cược xổ số",

  member_log: "Nhật ký thành viên",
  member_balance: "Tín dụng hội viên",
  master_credit: "Tín dụng tổng đại lý",
  member_credit_limit: "Giới hạn tín dụng hội viên",
  max_credit_limit: "Tối đa giới hạn tín dụng",
  min_max_bet: "Tổi thiểu/ Tối đa cược",
  min_bet: "Tối thiểu cược",
  max_bet: "Tối đa cược",
  max_per_match: "Tối đa mỗi trận đấu",
  mix_parlay: "Xiên",
  mmo_parlay: "Myanmar Parlay",
  money_line: "Dòng tiền",
  min: "Tối thiểu",
  max: "Tối đa",
  market_type: "Loại thị trường",
  match_time: "Thời gian trận đấu",
  match_id: "Tên trận",
  member_id: "Tên tài khoản",
  match: "Trận đấu",
  master_outstanding: "Cược chờ tổng đại lý",
  mode: "Chế độ",
  member_outstanding: "Cược chờ hồi viên",
  member_outstanding_4d: "Cược chờ hồi viên 4D",
  match_result: "Kết quả trận đấu",
  messages: "Tin nhắn",
  message: "Thông điệp",
  member_management: "Quản lý hội viên",
  member_bulk: "Thành viên số lượng lớn",
  manila_nocomm: "Game Play & Pretty Gaming & Evolution & Pragmatic & Sexy Gaming Livecasino 0% Commission",
  m4d: "4D",
  marketing_tools: "Công cụ tiếp thị",
  min_credit: "Tín dụng tối thiểu",

  new: "Mới",
  new_login_id: "Tên đăng nhập mới",
  new_username: "Tên đăng nhập mới",
  new_password: "Mật khẩu mới",
  new_security_code: "Mã bảo vệ mới",
  new_account: "Tài khoản mới",
  next: "Kế tiếp",
  no_goal: "Không bàn thắng",
  "no/": "Thứ tự.",
  normal: "Bình thường",
  normal_announcements: "Thông báo bình thường",

  on: "Mở",
  off: "Đóng",
  ok: "đồng ý",
  over: "Tài",
  overview: "Tổng quat",
  old_password: "Mật khẩu cũ",
  outstanding: "Cược chờ",
  outstanding_balance: "Số dư chưa thanh toán",
  over_under: "Tài xỉu",
  odd_even: "OChẵn/Lẻ",
  ou: "Tài xỉu",
  oe: "Chẵn/Lẻ",
  others: "Khác",
  odd: "Chẵn",
  oxt: "1X2",
  outright: "Vô địch",
  others_min_bet: "@:ui.others @:ui.min_bet",
  others_max_bet: "@:ui.others @:ui.max_bet",
  others_max_per_match: "@:ui.others @:ui.max_per_match",
  odds_display: "Hiển thị chẵn",
  online_player: "Người chơi trực tuyến",
  opening_balance: "Tín dụng đầu",
  oxtoeml: "@:m.BT_OE/@:m.BT_1X2/@:m.BT_ML",
  oxthdp: "3 cách kèo chấp",
  others_sports: "Những môn thể thao khác",

  pending: "Đang duyệt",
  platform: "Nền tảng",
  pt: "Thầu",
  password: "Mật khẩu",
  profile_id: "Hồ sơ ID",
  parent_id: "ID cấp cha",
  page_size: "Kích thước trang",
  profile: "Hồ sơ",
  payment_option: "Phương thức thanh toán",
  part_one: "Phần một",
  part_two: "Phần hai",
  position_taking: "Thầu",
  preview_settings: "Xem trước Cài đặt",
  preview: "Xem trước",
  parlay: "Xiên",
  position_taking_log: "Lịch sử thầu",
  platform_code: "Nền tảng mã",
  platform_name: "Nền tảng tên",
  pay: "Trả / Trả toàn bộ",
  payout: "Thanh toán",
  product: "Sản phẩm",
  pending_matches: "Những Trận Đấu chờ",
  pt_share: "Chia sẽ thầu",
  platform_settings: "Nền tảng Cài đặt",
  parlay_min_bet: "@:ui.parlay @:ui.min_bet",
  parlay_max_bet: "@:ui.parlay @:ui.max_bet",
  parlay_max_per_match: "@:ui.parlay @:ui.max_per_match",
  parlay_upline_pt : "@:ui.parlay @:ui.upline_pt",
  parlay_account_pt : "@:ui.parlay @:ui.account_pt",
  parlay_upline_remaining : "@:ui.parlay @:ui.upline_remaining",
  parlay_account_min : "@:ui.parlay @:ui.account_min",
  parlay_mmo_upline_pt : "Parlay MMO @:ui.upline_pt",
  parlay_mmo_account_pt : "Parlay MMO @:ui.account_pt",
  parlay_mmo_upline_remaining : "Parlay MMO @:ui.upline_remaining",
  parlay_mmo_account_min : "Parlay MMO @:ui.account_min",
  personal: "Cá nhân",
  personal_message: "Thông điệp cá nhân",
  password_reset: "Đặt lại mật khẩu",
  password_update: "Mật khẩu cập nhật",

  refresh: "Làm mới",
  reset: "Cài lại",
  remaining_credit: "Tín dụng còn lại",
  remaining: "Còn lại",
  rate: "Tỷ lệ",
  report: "Báo cáo",
  running: "Đang chạy",
  remark: "Chú ý",
  refund: "Hoàn tiền",
  range: "Phạm vi",
  reject: "Từ chối",
  reset_accumulate_win: "Đặt lại tích luỹ thắng",
  refno: "Tham khảo không",
  result: "ผลลัพธ์",
  room_1: "Công cộng",
  room_2: "Riêng tư",
  room_3: "Công cộng (Miễn phí)",

  status: "Trạng thái",
  succeed: "Thành công",
  submit: "Gửi đi",
  settings: "Cài đặt",
  save: "lưu",
  search: "Tìm kiếm",
  suspend: "Đình chỉ",
  security_tag: "Thẻ bảo mật",
  sub_account: "Tài khoản phụ",
  search_and_copy: "Tìm kiếm và sao chép",
  search_existing: "Tìm kiếm hiện có",
  skip: "Bỏ qua",
  settings_limit: "Cài đặt Giới hạn",
  sportsbook: "Thể thao",
  slot_games: "Trò chơi xèng",
  soccer: "Bóng đá",
  sport_types: "Các loại thể thao",
  settlement: "Thống kê",
  submatch_id: "Sub-match ID",
  score: "Ghi bàn",
  submatch_code: "Sub-match Mã",
  settlement_list: "Danh sách giải quyết",
  sub_total: "Sub Tổng số",
  settle_amount: "Số tiền giải quyết",
  settlement_history: "Lịch sử định cư",
  // settlement_member: "Chi tiết giải quyết thành viên",
  sport_type: "Loại thể thao",
  slot_platform: "Nền tẳng trò chơi xèng",
  simple_report: "Báo cáo đơn giản",
  status_update: "Cập nhật trạng thái",
  set_authority: "Cài đặt quyền",
  soccer_hdp_upline_pt : "@:ui.soccer @:ui.hdp @:ui.upline_pt",
  soccer_hdp_account_pt : "@:ui.soccer @:ui.hdp @:ui.account_pt",
  soccer_hdp_upline_remaining : "@:ui.soccer @:ui.hdp @:ui.upline_remaining",
  soccer_hdp_account_min : "@:ui.soccer @:ui.hdp @:ui.account_min",
  soccer_1x2_upline_pt : "@:ui.soccer @:ui.oxt @:ui.upline_pt",
  soccer_1x2_account_pt : "@:ui.soccer @:ui.oxt @:ui.account_pt",
  soccer_1x2_upline_remaining : "@:ui.soccer @:ui.oxt @:ui.upline_remaining",
  soccer_1x2_account_min : "@:ui.soccer @:ui.oxt @:ui.account_min",
  soccer_others_upline_pt : "@:ui.soccer @:ui.others @:ui.upline_pt",
  soccer_others_account_pt : "@:ui.soccer @:ui.others @:ui.account_pt",
  soccer_others_upline_remaining : "@:ui.soccer @:ui.others @:ui.upline_remaining",
  soccer_others_account_min : "@:ui.soccer @:ui.others @:ui.account_min",
  hdp_mmo_upline_pt : "@:ui.hdp MMO @:ui.upline_pt",
  hdp_mmo_account_pt : "@:ui.hdp MMO @:ui.account_pt",
  hdp_mmo_upline_remaining : "@:ui.hdp MMO @:ui.upline_remaining",
  hdp_mmo_account_min : "@:ui.hdp MMO @:ui.account_min",
  slots_upline_pt : "@:ui.slots @:ui.upline_pt",
  slots_account_pt : "@:ui.slots @:ui.account_pt",
  slots_upline_remaining : "@:ui.slots @:ui.upline_remaining",
  slots_account_min : "@:ui.slots @:ui.account_min",
  soccer_min_bet: "@:ui.soccer @:ui.min_bet",
  soccer_max_bet: "@:ui.soccer @:ui.max_bet",
  soccer_max_per_match: "@:ui.soccer @:ui.max_per_match",
  slots: "Xèng",
  security_update: "Cập nhật bảo mật",
  security_code: "Mã bảo vệ",
  success: "Sự thành công",
  stock: "Cổ phần",
  special: "Đặc biệt",
  special_announcements: "Thông báo đặc biệt",
  seconds: "Giây",
  security_disable: "Bỏ mã bảo vệ",
  select_all: "Chọn tất cả",
  system_parlay: "Cược xiên hệ thống",
  settlement_agent_bulk: "Số lượng lớn đại lý thanh toán",
  settlement_agent: "Đại lý dàn xếp",
  settle_agent: "Đại lý dàn xếp",
  settlement_member_bulk: "Số lượng lớn thành viên dàn xếp",
  settlement_member: "Thành viên dàn xếp",
  settle_member: "Thành viên dàn xếp",

  schedule_1: "Thứ hai | Thứ hai",
  schedule_2: "Thứ ba | Thứ ba",
  schedule_3: "Thứ tư | Thứ tư",
  schedule_4: "Thứ năm | Thứ năm",
  schedule_5: "Thứ sáu | Thứ sáu",
  schedule_6: "Thứ bảy | Thứ bảy",
  schedule_7: "Chủ nhật | Chủ nhật",

  twtn: "Lật kèo",
  total_outstanding: "Tổng mã cược đang chạy",
  target_id: "Tên mục tiêu",
  target_action: "Thao tác mục tiêu",
  total: "Toàn bộ",
  types: "Các loại",
  total_goal: "Tổng số bàn thắng",
  tennis: "Quần vợt",
  today: "Hôm nay",
  thisweek: "Tuần này",
  thismonth: "Tháng này",
  transaction_log: "Lịch sử giao dịch",
  total_bet: "Tổng cược",
  transaction_date: "Giao dịch Ngày / giờ",
  transfer_method: "Phương thức chuyển tiền",
  turnover: "Doanh số",
  total_balance: "Tổng tín dụng",
  total_tran: "Tổng số giao dịch",
  total_base: "Tổng cược của hội viên",
  tennis_min_bet: "@:ui.tennis @:ui.min_bet",
  tennis_max_bet: "@:ui.tennis @:ui.max_bet",
  tennis_max_per_match: "@:ui.tennis @:ui.max_per_match",
  top_winner: "Top 10 người thắng của tháng",
  top_turnover: "Top 10 doanh sách lớn nhất của tháng",
  top_loser: "Top 10 người thua cuộc của tháng",
  type: "Dạng",
  total_downline: "Tổng cấp dưới",
  to: "Đến",
  transfer: "Hoàn tiền về",
  transfer_list: "Dnh sách hoàn tiền về",
  transfer_history: "Lịch sử hoàn tiền về",
  this_month: "Tháng này",
  this_week: "Tuần này",
  total_accepted: "Tổng số được chấp nhận",
  total_rejected: "Tổng số bị từ chối",
  total_stake: "Tổng số cổ phần",
  total_winlose: "Tổng số Thắng / Thua",
  Total_member: "Tổng số Thành viên",
  tournament: "Giải đấu",
  tournament_jackpot: "Giải độc đắc của giải đấu",
  tournament_refund_list: "Danh sách hoàn trả giải đấu",

  under: "Xỉu",
  upline_id: "Tuyến trên ID",
  unblock: "Mở khóa",
  update: "Cập nhật",
  username: "Tên tài khoản",
  update_commission_sb: "Hoa hồng thể thao",
  update_commission_lc: "hoa hồng sòng bạc trực tuyến",
  update_commission_sl: "hoa hồng trò chơi xèng",
  update_commission_lo: "hoa hồng xổ số",
  update_commission_kn: "hoa hồng keno",
  update_commission_cf: "Hoa hồng đá gà",
  update_commission_lt: "Hoa hồng xổ số",
  update_bet_limit_lc: "Giới hạn cược thể thao",
  update_bet_limit_sb: "Giới hạn cược sòng bạc trực tuyến",
  update_bet_limit_lo: "Giới hạn cược xổ số",
  update_bet_limit_kn: "Giới hạn cược keno",
  update_bet_limit_cf: "Giới hạn cược đá gà",
  update_bet_limit_lt: "Giới hạn cược xổ số",
  update_position_sb: "Thầu thể thao",
  update_position_lc: "Thầu sòng bạc trực tuyến",
  update_position_sl: "Thầu trò chơi xèng",
  update_position_lo: "Thầu xổ số",
  update_position_kn: "Thầu keno",
  update_position_cf: "Thầu đá gà",
  update_position_lt: "Thầu xổ số",
  update_account: "Cập nhật tài khoản",
  update_platform: "Cập nhật nền tảng",
  upline_pt: "Thầu cấp trên",
  upline_remaining: "Thầu còn lại",
  unblock_profile: "mở khoá hồ sơ",
  unselect_all: "Bỏ chọn tất cả",

  view_details: "Xem chi tiết",
  view_downline: "Xem cấp dưới",
  value: "Giá trị",
  valid_turnover: "Doanh thu hợp lệ",
  void: "Huỷ",

  winlose_limit: "Giới hạn thắng thua",
  wallet: "Ví tiền",
  winlose: "Thắng thua",
  win_limit: "Giới hạn thắng",
  win_limit_multiplier: "Giới hạn thắng liên tục",
  win_limit_tooltips: "Chỉ áp dụng cho sòng bạc trực tuyến.",
  win_limit_tooltips1: "Do độ trễ API của sòng bạc, người chơi có thể tiếp tục đặt cược trong vài phút sau khi đạt đến Giới hạn thắng.",
  win_limit_0: "Không giới hạn",
  win_limit_1: "Giới hạn tín dụng x 1",
  win_limit_2: "Giới hạn tín dụng x 2",
  win_limit_5: "Giới hạn tín dụng x 5",
  win_limit_10: "Giới hạn tín dụng x 10",
  win_limit_20: "Giới hạn tín dụng x 20",
  winlose_column1: "Thắng/Thua",
  winlose_column2: "Hoa hồng",
  winlose_today: "Thắng thua hôm nay",
  winlose_yesterday: "Thắng thua hôm qua",
  winner: "Người chiến thắng",
  won: "Thắng",
  win_half: "Thắng nửa",
  withdrawal: "Rút tiền",

  yesterday: "Hôm qua",
  yesterday_balance: "Tín dụng hôm qua",

  provider_evo: "Evolution",
  provider_gp: "Game Play",
  provider_vivo: "Vivo suite",
  provider_sa: "SA Gaming",
  provider_ct: "CT855",
  provider_ptg: "Pretty Gaming",
  provider_yb: "Yeebet",
  "provider_pp-c": "Pragmatic",
  provider_lotto: "Lotto",
  provider_keno: "Keno",
  provider_cockfight: "THỂ THAO ĐIỆN TỬ Hai",
  provider_lottery: "Xổ số",
  provider_ar: "Arcadia Gaming",
  provider_slots: "Slots (Live22)",
  provider_pgs: "Slots (PGSoft)",
  provider_pp: "Slots (PP)",
  provider_jk: "Slots (Joker)",
  provider_sp: "Slots (SimplePlay)",
  provider_jili: "Slots (Jili)",
  provider_uu: "Slots (UU)",
  provider_db: "Slots (DBHash)",
  provider_wow: "Slots (WOW Gaming)",
  provider_ai: "AI Livecasino",
  provider_wf: "Slots (WF Gaming)",
  provider_next: "Slots (Next)",
  provider_dbp: "Poker (DBHash)",
  provider_epw: "Poker (Epicwin)",
  provider_sexybcrt: "Sexy Baccarat",

  timer: "Hẹn giờ",
  no_refresh: "Không làm mới",
  actual_yesterday_balance: "Số dư thực tế ngày hôm qua",

  loading: "Đang tải ...",
  slide_puzzle: "Trượt câu đố",
  drag_to_verify: "Kéo để xác minh",
  running_score: "Ghi bàn",
  unblock_account: "Mở khóa tài khoản",
  password_expired: "Mật khẩu đã hết",

  lotto_upline_pt : "@:ui.lotto @:ui.upline_pt",
  lotto_account_pt : "@:ui.lotto @:ui.account_pt",
  lotto_upline_remaining : "@:ui.lotto @:ui.upline_remaining",
  lotto_account_min : "@:ui.lotto @:ui.account_min",
  keno_upline_pt : "@:ui.keno @:ui.upline_pt",
  keno_account_pt : "@:ui.keno @:ui.account_pt",
  keno_upline_remaining : "@:ui.keno @:ui.upline_remaining",
  keno_account_min : "@:ui.keno @:ui.account_min",
  cockfight_upline_pt : "@:ui.cockfight @:ui.upline_pt",
  cockfight_account_pt : "@:ui.cockfight @:ui.account_pt",
  cockfight_upline_remaining : "@:ui.cockfight @:ui.upline_remaining",
  cockfight_account_min : "@:ui.cockfight @:ui.account_min",
  lottery_upline_pt : "@:ui.lottery @:ui.upline_pt",
  lottery_account_pt : "@:ui.lottery @:ui.account_pt",
  lottery_upline_remaining : "@:ui.lottery @:ui.upline_remaining",
  lottery_account_min : "@:ui.lottery @:ui.account_min",

};